import Chip from "@mui/material/Chip";
const KeywordChip = ({ keyword }) => {
    return <Chip label={keyword} />;
};

export default KeywordChip;
